import { useRef, useState } from 'react';
import { useParams } from 'react-router-dom';
import { InternalOverlay } from 'react-rainbow-components';
import { useOutsideClick, useWindowResize } from '@rainbow-modules/hooks';
import ButtonIcon from 'components/ButtonIcon';
import AppsIcon from 'components/icons/apps';
import { auth, db } from 'data/firestore/firebase';
import { DropdownContainer, StyledVoxityAppPicker } from './styled';

import '@voxityai/auth/styles';

interface VoxityAppSwitcherProps {
    className?: string;
}

const VoxityAppSwitcher = ({
    className,
}: VoxityAppSwitcherProps) => {
    const { agentId = '' } = useParams<{ agentId?: string }>();
    const buttonRef = useRef<any>(null);
    const dropdownRef = useRef<HTMLDivElement>(null);
    const [isOpen, setIsOpen] = useState(false);

    useWindowResize(() => setIsOpen(false), isOpen);
    useOutsideClick(dropdownRef, () => setIsOpen(false), isOpen);

    const toggle = () => setIsOpen(!isOpen);

    return (
        <>
            <ButtonIcon
                ref={buttonRef}
                className={className}
                icon={<AppsIcon />}
                onClick={toggle}
            />
            <InternalOverlay
                isVisible={isOpen}
                // eslint-disable-next-line @typescript-eslint/ban-ts-comment
                // @ts-ignore
                triggerElementRef={() => buttonRef.current?.htmlElementRef}
            >
                <DropdownContainer ref={dropdownRef}>
                    <StyledVoxityAppPicker variant="list" firestore={db} auth={auth} agentId={agentId} />
                </DropdownContainer>
            </InternalOverlay>
        </>
    );
};
export default VoxityAppSwitcher;
